export const buySellOptions = [
  'BUY',
  'SELL',
  'BUY/SELL',
  'SELL/BUY',
  'PAYER',
  'RECEIVER',
  'UNKNOWN'
];



// WEBPACK FOOTER //
// ./src/utility/commonFieldOptions.js